import { useCallback } from 'react';

import { USER_PROGRESS_ENTITY, USER_PROGRESS_EVENT } from '~/const';
import { useIsOLCO, useOnlineContentConnector } from '~/context/OnlineContentConnectorContext';
import { useSsrContext } from '~/context/SsrContext';
import { useTenantContext } from '~/context/TenantProvider';
import { useUserInfoContext } from '~/context/UserInfoProvider';
import sendUserProgressRequest from '~/utils/sendUserProgressRequest';

const useSendUserProgress = () => {
  const { callbackUrl, subdomain, userGuid, sessionToken, nocc } = useOnlineContentConnector();
  const { isOLCOWithoutNavigation } = useIsOLCO();
  const { tenant } = useTenantContext();
  const { userInfo } = useUserInfoContext();
  const { apiUrl } = useSsrContext();

  const sendUserProgress = useCallback(
    (event: USER_PROGRESS_EVENT, entityType: USER_PROGRESS_ENTITY, entityId: string) => {
      //nocc used to ignore sending progress events to OCC
      if (userGuid && userInfo?.id && !nocc) {
        sendUserProgressRequest(apiUrl, {
          callbackUrl,
          subdomain,
          userGUID: userGuid,
          sessionToken,
          entityType: isOLCOWithoutNavigation ? entityType : USER_PROGRESS_ENTITY.Tenant,
          entityId: isOLCOWithoutNavigation ? entityId : tenant?.id || '',
          event,
          learnerId: userInfo?.id || '',
        });
      }
    },
    [
      callbackUrl,
      subdomain,
      userGuid,
      sessionToken,
      userInfo,
      tenant,
      isOLCOWithoutNavigation,
      apiUrl,
      nocc,
    ],
  );

  return {
    sendUserProgress,
  };
};

export default useSendUserProgress;
